import axios from 'axios';
import url from '@/url';

const authHeaders = () => ({
  headers: {
    'X-Authorization': localStorage.getItem('token'),
  },
});

const unwrap = (response) => {
  const result = response?.data?.result;
  if (result && (result.status === 200 || result.status === 201)) {
    return result.data;
  }
  return null;
};

/**
 * Every tenant with its native-call rollout config, in a single request.
 * Each row is { tenant: {id, code, name, is_active}, config: { CODE: value|null } }.
 *
 * A null value means no row exists, which the backend reads as disabled — the
 * switches are never on by accident.
 */
export const listNativeCallConfigs = async () => {
  const response = await axios.get(
    process.env.VUE_APP_SERVICE_URL + url.native_call_configs,
    authHeaders(),
  );
  const data = unwrap(response);
  // Backend wraps response as { data: [ ... ] } — unwrap one level.
  return data?.data ?? data ?? [];
};

/**
 * Update one tenant's native-call config.
 * Only the codes present in the payload are written; an omitted code is left
 * untouched, and sending null / '' deletes the row, which turns that switch off.
 *
 * There is no apply-to-all counterpart on purpose: enabling this changes how
 * every call on a branch reaches its devices, so it is rolled out per branch.
 */
export const upsertTenantNativeCallConfig = async (tenantId, payload) => {
  const response = await axios.put(
    `${process.env.VUE_APP_SERVICE_URL}${url.tenant_native_call_config}${tenantId}/native-call-config`,
    payload,
    authHeaders(),
  );
  const data = unwrap(response);
  return data?.data ?? data ?? {};
};
